// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--GdnTB","rate":"_02712f2b3b--rate--jgmFs"};